import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GlobalsService } from './globals.service';

/**
 * Http requests
 *
 * @author jbruenker
 */
@Injectable({ providedIn: 'root' })
export class HttpService {

    constructor(private httpClient: HttpClient,
        private globals: GlobalsService) {
    }

    public getJson<T>(endpoint: string): Observable<T> {
        const url = this.constructUrl(endpoint);
        console.log(`GET ${url}`);
        return this.httpClient.get<T>(url, {withCredentials: true});
    }

    public getString(endpoint: string): Observable<string> {
        const url = this.constructUrl(endpoint);
        console.log(`GET ${url}`);
        return this.httpClient.get(url, {responseType: 'text', withCredentials: true});
    }

    private constructUrl = (endpoint: string): string => {
        const urlParams = `user=${this.globals.accountId}`;
        return `${this.globals.apiURL}${endpoint[0] == '/' ? '' : '/'}${endpoint}?${urlParams}`;
    }
}
